import './SecondaryRegistration.css'
import React, { Component } from 'react'
import { API } from '../../API'
import { PORT } from '../../config'
import { notify } from 'react-notify-toast'
import '../User2/UserProfile.css'

import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber }  from 'react-phone-number-input'

import SignupContainer from '../Signup-Login/SignupContainer'
import FormField from '../../Components/FormField/FormField'
import FormDropdown from '../../Components/FormField/FormDropdown'
import ConfirmButton from '../../Components/Buttons/ConfirmButton'
import CancelButton from '../../Components/Buttons/CancelButton'
import HoverIcon from '../../Components/FormField/HoverIcon-nova'
import Modal from '../../Components/Modal/Modal'
import PasswordToggle from '../../Components/FormField/PasswordToggle'
import CheckableButton from '../../Components/CheckableButton/CheckableButton'
import PasswordStrengthMeter from '../Register/PasswordStrengthMeter'
import TermsAndConditionsTeacher from '../Register/TermsAndConditionsTeacher'

import { connect } from 'react-redux'
import { updateToRoot } from '../../redux/college/college.actions'

const URL = PORT
const isNumeric = (value) => {
  return /^[0-9]*$/.test(value)
}

class SecondaryRegistrationPersonnel extends Component {
  constructor(props) {
    super(props)
    // console.log(props.location.state)
    this.state = {
      email: props.location.state ? props.location.state.personnel_email : '',
      institute: props.location.state
        ? props.location.state.institution_name
        : '',
      role: props.location.state ? props.location.state.personnel_role : '',
      first_name: props.location.state
        ? props.location.state.personnel_first_name
        : '',
      last_name: props.location.state
        ? props.location.state.personnel_last_name
        : '',
      contact_no: props.location.state
        ? props.location.state.personnel_mobile
        : '',
      secret_answer1: '',
      secret_answer2: '',
      contact_number_verified: props.location.state
        // ? props.location.state.contact_number_verified
        ? true
        : false,
      showPopup: false,
      showTCPopup: false,
      viewedTC: false,
      isMobileValid: false,
      showConfirmNumber: false,
      icon: 'information-outline',
      user_id: '',
      hovered_text:
        'We will use your mobile number to contact you when shifts arise that match your availability',
      password: '',
      checkPassword: [],
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
    }
  }

  handleInstitute = (event) => {
    event.preventDefault()
    this.setState({
      institute: event.target.value,
    })
  }

  handleRole = (event) => {
    event.preventDefault()
    this.setState({
      role: event.target.value,
    })
  }

  hanldeLastName = (event) => {
    event.preventDefault()
    this.setState({
      last_name: event.target.value,
    })
  }

  hanldeFirstName = (event) => {
    event.preventDefault()
    this.setState({
      first_name: event.target.value,
    })
  }

  hanldeContactNo = (event) => {
    event.preventDefault()
    if (event.target.value.length === 8 && !isNaN(event.target.value.length)) {
      this.setState({
        contact_no: event.target.value,
        isMobileValid: true,
      })
    } else {
      this.setState({
        contact_no: event.target.value,
        isMobileValid: false,
      })
    }
  }

  handleNumberChange = (event) => {
    this.setState({value:event})
    this.setState({contact_no: event})
    }

  handleClickRgister = (event) => {
    event.preventDefault()
    const props = this.props
    if (document.getElementById('terms-co-check').checked === true) {
      if (!this.state.viewedTC) {
        notify.show(
          "Please view the Terms and Conditions before accepting them."
        );
        document.getElementById("terms-co-check").checked = false;
        return;
      }
      // if (this.state.contact_number_verified) {
        // if (
        //   /^[aA-zZ-]+$/g.test(this.state.first_name) &&
        //   /^[aA-zZ-]+$/g.test(this.state.last_name)
        // ) {

        API.setPersonnelSecondRegister({
          email: this.state.email,
          contact_no: this.state.contact_no,
          // contact_number_verified: this.state.contact_number_verified,
          contact_number_verified: true,
          secret_question1: document.querySelector('#secret_question1').value,
          secret_question2: document.querySelector('#secret_question2').value,
          secret_answer1: this.state.secret_answer1,
          secret_answer2: this.state.secret_answer2,
          password: this.state.password,
          email_verification_status: true,
        })
          .then((result) => {
            window.localStorage.setItem('token', result.data.token)
            API.getInstitutionData({ id: result.data.user.institution })
              .then((instData) => {
                const inst = instData.data
                let campuses = []
                let personnel = []
                let classes = []
                API.getMultipleCampusById(inst.campuses)
                  .then((cams) => {
                  campuses = cams.data
                  API.getPersonnelByInstId(inst._id)
                    .then((res) => {
                    personnel = res.data
                    API.getClassesByCampuses(inst.campuses)
                      .then((res) => {
                      // console.log("classes", res.data)
                      classes = res.data
                      props.updateToRoot(
                        result.data.user,
                        'personnel',
                        inst,
                        campuses,
                        personnel,
                        classes,
                      )
                      const path = '/PersonnelDashboard'
                      props.history.push(path)
                    })
                  })
                })
              })
              .catch((err) => {
                console.log(err)
              })
          })
          .catch((err) => {
            if (
              err.isAxiosError &&
              err.response &&
              err.response.status === 401 &&
              err.response.data.msg ===
                'Personnel email cannot be used as Institution email'
            ) {
              notify.show(
                'Personnel email cannot be used as an Institution email.',
                'custom',
                5000,
                { background: '#050505', text: '#FFFFFF' },
              )
            } else {
              console.log(err)
            }
          })
        // axios
        //   .put(`${URL}/personnel/secondaryregister`, {
        //     email: this.state.email,
        //     contact_no: this.state.contact_no,
        //     contact_number_verified: this.state.contact_number_verified,
        //     secret_question1: document.querySelector("#secret_question1")
        //       .value,
        //     secret_question2: document.querySelector("#secret_question2")
        //       .value,
        //     secret_answer1: this.state.secret_answer1,
        //     secret_answer2: this.state.secret_answer2,
        //     password: this.state.password,
        //     email_verification_status: true,
        //   })
        //   .then((res) => {
        //     window.localStorage.setItem("token", res.data.token)
        //     const path = {
        //       pathname: `/personnelDashboard`,
        //       state: res.data,
        //     }
        //     props.history.push(path)
        //   })
        //   .catch((err) => {
        //     notify.show("Server Error. Please try again later.")
        //     console.log(err)
        //   })
        // } else {
        //   notify.show("Please use only letters in first name or last name")
        // }
      // } else {
      //   notify.show(
      //     'Please verify your mobile number to proceed. We will use your number to contact you when shifts arrive that match your availability.',
      //     'custom',
      //     5000,
      //     { background: '#050505', text: '#FFFFFF' },
      //   )
      // }
    } else {
      notify.show(
        'You must accept the Terms & Conditions in order to complete registration.',
        'custom',
        5000,
        { background: '#050505', text: '#FFFFFF' },
      )
    }
  }

  hanldeSecretAnswer1 = (event) => {
    event.preventDefault()
    this.setState({
      secret_answer1: event.target.value,
    })
  }

  hanldeSecretAnswer2 = (event) => {
    event.preventDefault()
    this.setState({
      secret_answer2: event.target.value,
    })
  }

  handleShowPopUp = () => {
    this.setState({
      showPopup: !this.state.showPopup,
    })
  }

  handleTCShowPopUp = () => {
    this.setState({
      showTCPopup: !this.state.showTCPopup,
    })
  }

  handleConfirmNumber = () => {
    const mobile = document.querySelector('#verifycode').value
    if (mobile) {
        if (isValidPhoneNumber(mobile)) {
            this.setState({
                showConfirmNumber: true,
                isMobileValid: false,
              })
        } else {
            notify.show('Invalid phone number')
        }
    } else {
        notify.show('Phone number required')
    }
  }

  handleChangeNumber = () => {
    this.setState({
      showConfirmNumber: false,
      isMobileValid: false,
      contact_number_verified: false,
    })
  }

  handleCancelCode = () => {
    this.setState({
      showPopup: false,
    })
    this.handleChangeNumber()
  }

  verify_contact_number = () => {
    this.setState({ contact_number_verified: true })
    this.handleIcon()
  }

  handleIcon = () => {
    this.setState({
      icon: 'checkbox-marked-circle check-green',
      hovered_text: 'Verified',
    })
  }

  handleRequestOTP = (event) => {
    event.preventDefault()
    const mobile = document.querySelector('#verifycode').value
    const email = document.querySelector('#email').value
    // console.log(document.querySelector("#mobile").value.length)
    this.setState({
      isMobileValid: false,
      showConfirmNumber: false,
    })

    const popup = this.handleShowPopUp

    API.requestOTP({
      params: {
        email: email,
        mobile: mobile.substring(1),
      },
    })
      .then(function (response) {
        popup()
        // console.log("res", response.data)
        window.auth_user_id = response.data.auth_user_id
      })
      .catch(function (error) {
        console.log('error', error)
      })
  }

  handlePassword = (e) => {
    let password = e.target.value
    let passwordarray = []
    if (!password.match('.{8,}')) passwordarray.push('8 characters')
    if (!password.match('(?=.*?[0-9])')) passwordarray.push('1 digit')
    this.setState({ checkPassword: passwordarray })
  }

  togglePassword = () => {
    //Toggles between showing and hiding password
    this.setState({ showPassword: !this.state.showPassword })
  }

  toggleConfirmPassword = () => {
    //Toggles between showing and hiding password
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword })
  }

  togglePopup = () => {
    const codes = document.querySelector('#verifycode1').value
    const popup = this.handleShowPopUp
    const email = document.querySelector('#email').value
    const verify_contact_number = this.verify_contact_number
    if (isNumeric(codes)) {
      API.personnelVerifyOTP({
        id: window.auth_user_id,
        token: codes,
        email: email,
      })
        .then(function (response) {
          popup()
          verify_contact_number()
          // console.log(response)
          notify.show('Mobile number verified')
        })
        .catch(function (error) {
          console.log(error)
          notify.show('Please enter the exact code sent to your phone')
        })
    } else {
      console.log('Please enter numbers only')
      notify.show('Please enter numbers only')
    }
  }

  showTermsAndCo = () => {
    this.setState({ viewedTC: true, showTCPopup: true })
    // document.getElementById('modal-container-TermsAndCo').style.display = 'block';
    //document.getElementById("container").style.height = "0px";
  }

  hideTermsAndCo = () => {
    this.setState({ showTCPopup: false })
    // document.getElementById('modal-container-TermsAndCo').style.display = 'none';
  }

  acceptButtonCheck = (flag) => {
    if (flag) {
      document.getElementById('terms-co-check').checked = true
    } else {
      document.getElementById('terms-co-check').checked = false
    }
  }

  //Auto filling the form
  //A a function will pe added to submit the post the user Data extracted from google

  render() {
    //add a debugger so the application will automatically stop when executed
    // console.log(this.state.email)
    // console.dir(this.props.location.state)
    return (
      <>
        <SignupContainer
          heading="Registration Details"
          onSubmit={this.handleClickRgister}
        >
          <FormField
            label="Institution Name"
            type="text"
            icon="mdi mdi-home-modern"
            placeholder="Institute Name"
            value={this.state.institute}
            onChange={this.handleInstitute}
            disabled={true}
            //defaultValue={this.state.institute}
            autoFocus
            required
          />

          <FormField
            label="Role"
            type="text"
            icon="mdi mdi-home-modern"
            placeholder="Role"
            value={this.state.role}
            onChange={this.handleRole}
            disabled={true}
            //defaultValue={this.state.role}
            autoFocus
            required
          />

          <FormField
            label="Email"
            icon="email"
            id="email"
            name="email"
            placeholder="Email"
            disabled={true}
            value={this.state.email}
            //defaultValue={this.state.email}
            autoFocus
            required
          />

          <FormField
            label="First Name"
            id="firstname"
            name="firstname"
            placeholder="First Name"
            value={this.state.first_name}
            onChange={this.hanldeFirstName}
            disabled={true}
            //defaultValue={this.state.first_name}
            autoFocus
            required
          />

          <FormField
            label="Last Name"
            id="lastname"
            name="lastname"
            placeholder="Last Name"
            value={this.state.last_name}
            onChange={this.hanldeLastName}
            disabled={true}
            //defaultValue={this.state.last_name}
            required
          />
          <PhoneInput
            label="Mobile Number"
            icon="phone"
            inputComponent={FormField}
            id="verifycode"
            name="mobile"
            placeholder="Enter phone number"
            value={''}
            onChange={this.handleNumberChange}
            defaultCountry="AU"
            international
            autoFocus
            required
            // disabled={this.state.contact_number_verified}
            header={
              this.state.contact_number_verified ? (
                <HoverIcon
                  icon="check circle"
                  color="green"
                  type="success"
                  text="This document has been verified!"
                />
              ) : (
                <HoverIcon
                  icon="check circle"
                  color="grey"
                  text="We will use your mobile number to contact you when shifts arise that match your availability"
                />
              )
            }
            // sideButton={{
            //   label: this.state.contact_number_verified ? 'Change' : 'Verify',
            //   onClick: this.state.contact_number_verified
            //     ? this.handleChangeNumber
            //     : this.handleConfirmNumber,
            // }}
          >
            <Modal
              className="confirm-number-modal"
              header="MOBILE VERIFICATION"
              show={this.state.showConfirmNumber}
              onClose={() => this.setState({ showConfirmNumber: false })}
            >
              <h5 className="contact_numberConfirmation1">
                Is {this.state.contact_no} your number?
              </h5>
              <div className="row m-0">
                <div className="col-md-6" id="mobileVerify">
                  <CancelButton type="button" onClick={this.handleChangeNumber}>
                    No and Change
                  </CancelButton>
                </div>
                <div className="col-md-6 padding-for-mobile" id="mobileVerify">
                  <ConfirmButton type="button" onClick={this.handleRequestOTP}>
                    Yes and Proceed
                  </ConfirmButton>
                </div>
              </div>
            </Modal>

            <Modal
              className="confirm-number-modal"
              header="Confirmation Code"
              show={this.state.showPopup}
              onClose={this.handleCancelCode}
            >
              <div className="row m-0 d-flex justify-content-center">
                <FormField
                  type="number"
                  id="verifycode1"
                  name="verifycode"
                  className="col-md-6 mx-5"
                  placeholder="Enter the code sent to your phone"
                  autoFocus
                />
                <div className="col-md-6">
                  <CancelButton type="button" onClick={this.handleCancelCode}>
                    Cancel
                  </CancelButton>
                </div>
                <div className="col-md-6 padding-for-mobile">
                  <ConfirmButton type="button" onClick={this.togglePopup}>
                    Verify
                  </ConfirmButton>
                </div>
              </div>
            </Modal>
          </PhoneInput>

          <div className="passwords-wrapper">
            <FormField
              label="Password"
              icon="lock"
              type={this.state.showPassword ? 'text' : 'password'}
              placeholder="Enter Your Password"
              value={this.state.password}
              onChange={(e) => (
                this.setState({ password: e.target.value }),
                this.handlePassword(e)
              )}
              required
              header={
                this.state.checkPassword.length > 0
                  ? this.state.checkPassword.length > 1
                    ? ' must contain ' +
                      this.state.checkPassword[0] +
                      ' including ' +
                      this.state.checkPassword[1]
                    : ' must contain ' + this.state.checkPassword[0]
                  : null
              }
            >
              <PasswordToggle onClick={this.togglePassword} />
            </FormField>

            <PasswordStrengthMeter password={this.state.password} />

            <FormField
              label="Confirm Password"
              icon="lock"
              type={this.state.showConfirmPassword ? 'text' : 'password'}
              className={
                this.state.confirmPassword !== '' &&
                this.state.confirmPassword !== this.state.password
                  ? 'error-form-control'
                  : ''
              }
              placeholder="Repeat Your Password"
              value={this.state.confirmPassword}
              onChange={(e) =>
                this.setState({ confirmPassword: e.target.value })
              }
              required
            >
              <PasswordToggle onClick={this.toggleConfirmPassword} />
            </FormField>
          </div>

          <div className="secrets-wrapper">
            <FormDropdown
              label="Choose your first secret question"
              icon="account-check"
              id="secret_question1"
            >
              <option defaultValue="Mother’s maiden name">
                What is your mother’s maiden name?
              </option>
              <option value="First pet’s name">
                What was your first pet’s name?
              </option>
              <option value="Favourite movie">
                What is your favourite movie?
              </option>
            </FormDropdown>

            <FormField
              label="Answer"
              id="secret-answer-1"
              name="secret-answer-1"
              placeholder="Enter Your Answer"
              value={this.state.secret_answer1}
              onChange={this.hanldeSecretAnswer1}
              required
            />

            <FormDropdown
              label="Choose your second secret question"
              icon="account-check"
              id="secret_question2"
            >
              <option defaultValue="Best friend’s name">
                What is your best friend’s name?
              </option>
              <option value="Favourite class type or level to teach">
                What is your favourite class type or level to teach?
              </option>
              <option value="First street">
                What was the first street where you lived?
              </option>
            </FormDropdown>

            <FormField
              label="Answer"
              id="secret-answer-2"
              name="secret-answer-2"
              placeholder="Enter Your Answer"
              value={this.state.secret_answer2}
              onChange={this.hanldeSecretAnswer2}
              required
              className="mb-5"
            />
          </div>

          <div className="signup-tac signup-tac-secondary-registration-personnel">
            <CheckableButton checkbox id="terms-co-check">
              <span id="terms-co-check-accept">I Accept</span>
              <span
                id="terms-and-conditions-link"
                onClick={this.showTermsAndCo}
              >
                &nbsp;Terms and Conditions
              </span>
            </CheckableButton>
          </div>

          <ConfirmButton className="signup-button" type="submit">
            Submit
          </ConfirmButton>
        </SignupContainer>

        <TermsAndConditionsTeacher
          show={this.state.showTCPopup}
          onClose={(event) => {
            this.acceptButtonCheck(
              !document.getElementById('terms-co-check').checked,
            )
            this.hideTermsAndCo()
          }}
          onCancel={(event) => {
            this.acceptButtonCheck(false)
            this.hideTermsAndCo()
          }}
          onConfirm={(event) => {
            this.acceptButtonCheck(true)
            this.hideTermsAndCo()
          }}
        />
      </>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateToRoot: (...data) => dispatch(updateToRoot(...data)),
})

export default connect(null, mapDispatchToProps)(SecondaryRegistrationPersonnel)
